import React, { useEffect, useMemo } from 'react';
import { Box, LinkButton, Typography, DotLoader } from '@pinwheel/origami';
import { useOpts } from '../../../context';
import usePageTracking from '../../../hooks/usePageTracking';
import { SearchResults } from '../../../views/SearchLegacy/SearchResults';
import { EventAction, EventSurface } from '../../../types/events';
import MessageDetail from './MessageDetail';
import ProviderIcons from '../../../assets/PayrollProviderIcons.svg';
import useLinkNavigate from '../../../hooks/useLinkNavigate';
import { NUM_PLATFORMS_IN_VIEWPORT } from './constants';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
var NoResults = function () {
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var opts = useOpts();
    var fireProperEventType = opts.fireProperEventType, featureFlags = opts.featureFlags;
    return (React.createElement(React.Fragment, null,
        React.createElement(MessageDetail, { message: getLocalizedString('EMPLOYER_NOT_LISTED'), detail: getLocalizedString('NO_RESULTS_DESCRIPTION') }),
        // Hide logos entirely since we don't want to show any provider logos when this FF is turned on.
        // Context: https://pinwheel.atlassian.net/browse/CON-459
        featureFlags.useGenericProviderLogos ? null : (React.createElement("img", { style: { display: 'block', margin: 'auto' }, src: ProviderIcons, alt: "Payroll Provider Icons" })),
        React.createElement(Typography, { variant: "caption", align: "center", sx: { marginTop: '16px' }, as: "div" },
            React.createElement(LinkButton, { onClick: function () {
                    fireProperEventType(EventAction.TAP_PROVIDER_SEARCH_PROMPT, opts);
                    navigate('/search/platforms');
                } }, getLocalizedString('SEARCH_PAYROLL_PROVIDERS')))));
};
var SearchTabResults = function (_a) {
    var onResultClick = _a.onResultClick, loading = _a.loading, results = _a.results, searchText = _a.searchText;
    var getLocalizedString = useGetLocalizedString();
    var opts = useOpts();
    var fireProperEventType = opts.fireProperEventType;
    var viewportResults = useMemo(function () { return (results ? results.slice(0, NUM_PLATFORMS_IN_VIEWPORT) : []); }, [results]);
    var fireImpressionEvent = usePageTracking(EventSurface.SEARCH_RESULTS).fireImpressionEvent;
    useEffect(function () {
        fireImpressionEvent({
            searchText: searchText,
            viewportResults: viewportResults,
        });
        // We only want to fire this when viewport results is updated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewportResults]);
    useEffect(function () {
        if (searchText && !loading) {
            if (results && results.length === 0) {
                fireProperEventType(EventAction.IMPRESSION_NO_RESULTS, opts, {
                    searchText: searchText,
                });
            }
        }
    }, [searchText, loading, results, fireProperEventType, opts]);
    return (React.createElement(Box, { sx: { flex: 1 } },
        !searchText && (React.createElement(MessageDetail, { message: getLocalizedString('SEARCH_PROMPT'), detail: getLocalizedString('SEARCH_TIP') })),
        searchText && loading && (React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            React.createElement(DotLoader, null))),
        searchText && !loading && (React.createElement("div", { className: "searchResultsContainer" },
            React.createElement(SearchResults, { results: results !== null && results !== void 0 ? results : [], onResultClick: function (r) { return onResultClick(r, viewportResults); }, loading: loading, lastItem: React.createElement(NoResults, null) })))));
};
export default SearchTabResults;
